import React from "react";
import ReactDOM from "react-dom";
import OurBrandsCountries from "./containers/OurBrandsCountries";
import {isEmpty} from "lodash";

export const initOurBrandsCountries = className => {
  let elements = document.querySelectorAll(`.${className}`);
  if (!isEmpty(elements)) {
    for (let element of elements) {
      let id = element.dataset.brandId;
      let excludedCountries = element.dataset.excludedCountries || '';
      ReactDOM.render(<OurBrandsCountries brandId={{id}} excludedCountries={excludedCountries}/>, element);
    }
  }
};
